import { Card, Col, Container, Row } from "react-bootstrap";
import Menu from "../../components/Menu";
import Users from "../../assets/img/silhueta-de-multiplos-usuarios.svg";
import Shopper from "../../assets/img/hospital.svg";
import Client from "../../assets/img/clients-im.svg";
import Doctor from "../../assets/img/doctor.svg";
import Agreements from "../../assets/img/plano-de-saude.svg";
import ConicalFlask from "../../assets/img/conical-flask.svg";
//import Pharmacy from "../../assets/img/pharmacy.svg";
import Calendar from "../../assets/img/calendar.svg";
import { Link } from "react-router-dom";
import { Settings as SettingsIcon } from "lucide-react";
import { useStateContext } from "../../contexts/ContextProvider";

function Settings() {
  const { hasRole } = useStateContext();

  const options = [
    {
      name: 'Usuários',
      icon: Users,
      link: '/users',
      show: hasRole(["Administrator", "OnSiteSupport", "OnlineSupport", "ProjectManager"])
    },
    {
      name: 'Clientes',
      icon: Shopper,
      link: '/shoppers',
      show: hasRole(["Administrator", "Finance", "OnSiteSupport", "OnlineSupport", "ProjectManager"])
    },
    {
      name: 'Locais de Atendimento',
      icon: Shopper,
      link: '/partners',
      show: hasRole(["Administrator", "Finance", "OnSiteSupport", "OnlineSupport", "ProjectManager", "Receptionist"])
    },
    {
      name: 'Pacientes',
      icon: Client,
      link: '/customers',
      show: hasRole(["Administrator", "Receptionist"])
    },
    {
      name: 'Profissionais',
      icon: Doctor,
      link: '/professionals',
      show: hasRole(["Administrator", "Finance", "OnSiteSupport", "OnlineSupport", "ProjectManager", "Receptionist"])
    },
    {
      name: 'Convênios',
      icon: Agreements,
      link: '/agreements',
      show: hasRole(["Administrator", "Finance", "ProjectManager"])
    },
    {
      name: 'Procedimentos',
      icon: ConicalFlask,
      link: '/procedures',
      show: hasRole(["Administrator", "Receptionist"])
    },
    // {
    //   name: 'Farmácias',
    //   icon: Pharmacy,
    //   link: '/pharmacies',
    //   show: hasRole(["Administrator", "Financial", "ProjectManager"])
    // }
    {
      name: 'Agendamentos',
      icon: Calendar,
      link: '/attendances',
      show: hasRole(["Administrator", "Receptionist"])
    }
  ]

  const screenTela =
    <div className='screenContainer' style={{ paddingRight: '0px' }}>
      <div className="row row-container">
        <h1 className="name-screen"> <SettingsIcon size={40} /> Administrativo</h1>

        <Container>
          <Row className="gy-3">
            {
              options
              .filter(option => option.show)
              .map(option => (
                <Col key={option.name} sm={12} md={6} lg={4}>
                  <Link to={option.link} style={{ textDecoration: 'none' }}>
                    <Card bg="secondary" text="light" className="card-menu">
                      <Card.Header>
                        <img style={{ width: '40px' }} alt={option.name} src={option.icon} />
                      </Card.Header>

                      <Card.Body className="mx-auto">
                        <Card.Title>
                          {option.name}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              ))
            }
            {/* <Col sm={12} md={6} lg={4}>
              <Card bg="dark" text="light">
                <Card.Header>
                  <img className="img-menu" alt="users" src={Users} />
                </Card.Header>

                <Card.Body className="mx-auto">
                  <Card.Title>
                    Usuários
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col> */}
          </Row>
        </Container>
      </div>
    </div>

  return <Menu screen={screenTela} />
}

export default Settings;